export enum ModerationContentType {
    problem = 0,
    suggestion = 1,
    comment = 2,
    solution = 3,
    workaround = 4,
}

export enum ModerationStatus {
    flagged = 1,
    rejected = 2,
    accepted = 3,
}

export enum ModerationListFilter {
    postsAwaitingModeration = 1,
    allReportedPosts = 2,
    recentlyCreatedPosts = 3,
    autoRejectedPosts = 4,
}

export class ModerationPost {
    public moderationStatus: ModerationStatus | null;
    public contentId: number;   // Id of comment, solution or problem
    public contentType: ModerationContentType;
    public content: string;

    public rootPostId: number;
    public rootPostTitle: string;

    public createdById: number;
    public createdByVsId: string;
    public createdByName: string;
    public createdByImageLink: string;
    public createdDateUtc: string;
    public isAuthorSuspended: boolean;
    public wasPostDeletedByUser: boolean;
}

export class User {
    public principalId: number;
    public vsid: string;
    public displayName: string;
    public email: string;
    public createdDate: string;
    public isSuspended: boolean;
    public profileImageUrl: string;
}
